import { useEffect } from 'react';

import { useLocation } from 'react-router-dom';

import { useSelfServe } from 'api/useSelfServe';
import { useChecklistState } from 'state/hooks/setup-checklist.hook';

import { SetupChecklistContent } from './Content';

export const SetupChecklistContainer: React.FC = () => {
  const location = useLocation();
  const publisherId = location.pathname.split('/project/')[1]?.split('/')[0];

  const { setTasksFromStatusList, hasCategories, isChecklistEnabled } =
    useChecklistState();

  const { getTasks } = useSelfServe(publisherId);

  useEffect(() => {
    setTasksFromStatusList(getTasks.data);
  }, [getTasks.data]);

  if (!isChecklistEnabled || !hasCategories) {
    return null;
  }

  return <SetupChecklistContent />;
};
